async function syncKickflipQtyToTopLevel() {
  const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());

  for (const item of cart.items) {
    const props = item.properties || {};

    // évite les boucles
    if (props._regios_synced === '1') continue;

    const raw = props._mczr_attributes;
    if (!raw || props['Quantité']) continue;

    let qtyStr = null;

    try {
      const arr = JSON.parse(raw);
      const found = Array.isArray(arr) ? arr.find(x => x && x.key === 'Quantité') : null;
      if (found && found.value != null) qtyStr = String(found.value);
    } catch (e) {
      continue;
    }

    if (!qtyStr) continue;

    const newProps = { ...props };
    newProps['Quantité'] = qtyStr;
    newProps['_tier'] = (Number(qtyStr) >= 10) ? '10plus' : 'lt10';
    newProps['_regios_synced'] = '1';

    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: item.key,
        quantity: item.quantity,   // ne change pas la qty Shopify ici
        properties: newProps
      })
    });
  }
}

// exécution au chargement + après les actions panier typiques
document.addEventListener('DOMContentLoaded', syncKickflipQtyToTopLevel);
document.addEventListener('cart:updated', syncKickflipQtyToTopLevel);
document.addEventListener('cart:refresh', syncKickflipQtyToTopLevel);
window.syncKickflipQtyToTopLevel = syncKickflipQtyToTopLevel;
